module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "question-dsc"
  }, [_vm._v(_vm._s(_vm.detail.title) + " " + _vm._s(_vm.detail.version))]), _c('div', {
    staticClass: "question-time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.detail.displayTime)))])]), _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "answer-dsc",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.contents)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-baebfcd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDynamics/DynamicsDetail.vue
// module id = 411
// module chunks = 0